import { forwardRef, type KeyboardEvent } from 'react'
import { displayNumeric } from '@/lib/keno-view'

/**
 * The reference number_input: a tel field showing the amount with thousands commas, a
 * clear (×) button in front, digits-only typing, Esc closes the popover.
 */
export const NumberInput = forwardRef<HTMLInputElement, {
  id: string
  value: number | ''
  onChange: (v: number | '') => void
  onReset: () => void
  onEscape: () => void
}>(function NumberInput({ id, value, onChange, onReset, onEscape }, ref) {
  function onKeyDown(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Escape') { onEscape(); return }
    const allowed = e.key.length > 1 || /^[0-9]$/.test(e.key) || e.ctrlKey || e.metaKey
    if (!allowed) e.preventDefault()
  }
  return (
    <span className={`${id} number-input`}>
      <a onClick={onReset}><svg className="icon-close"><use xlinkHref="#icon-close" /></svg></a>{' '}
      <input
        ref={ref}
        type="tel"
        id={id}
        autoComplete="off"
        tabIndex={1}
        value={value === '' ? '' : displayNumeric(value)}
        onKeyDown={onKeyDown}
        onChange={(e) => {
          const digits = e.target.value.replace(/[^0-9]/g, '')
          onChange(digits === '' ? '' : parseInt(digits, 10))
        }}
      />
    </span>
  )
})
